import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {ApplicationItemProps} from "../../pages/Application/Overview";
import {useNavigate} from "react-router-dom";

const AppCard = (props: ApplicationItemProps & { reFetch(): void; }): React.ReactElement => {
    const navigate = useNavigate();

    const deleteApp = async(id: string): Promise<void> => {
        const confirmed = window.confirm(`Do you really want to delete application: ${props.name}`);

        if(!confirmed) return;

        const result = await fetch(`/api/v1/Application/${id}`, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("echo-si-jwt")}`
            }
        });

        if(result.status == 200) {
            props.reFetch();
            return;
        }
        else return;
    };

    return (
        <Card>
            <CardContent style={{paddingBottom:0}}>
                <Typography variant="h5" component="div">{props.name}</Typography>
            </CardContent>
            <CardActions>
                <Button size="medium" onClick={() => {
                    window.navigator.clipboard.writeText(props.apiKey).then(() => {

                    });
                }}>Copy key</Button>
                <Button size="small" color="warning" onClick={() => navigate(`/applications/${props.id}/requests`)}>Logs</Button>
                <Button size="small" color="error" onClick={() => deleteApp(props.id)}>Delete</Button>
            </CardActions>
        </Card>
    );
};

export default AppCard;